import React, { useEffect, useState } from "react";

const Footer = ({ isActive }) => {
  const [display, setDisplay] = useState("none");

  useEffect(() => {
    if (isActive) {
      setDisplay("flex");
    } else {
      setDisplay("none");
    }
  }, [isActive]);

  return (
    <div className="footer" style={{ display: display }}>
      <p>Made with &nbsp;❤&nbsp; by quanle</p>
      <span className="copyright">
        &copy; {new Date().getFullYear()}
      </span>
    </div>
  );
};

export default Footer;
